// extracted by mini-css-extract-plugin
module.exports = {"section":"footer-ctas_section__2Znye"};